import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs, query, where, addDoc, updateDoc, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import OnboardingMultipleChoiceQuestion from "./OnboardingMultipleChoiceQuestion";
import OnboardingTrueFalseQuestion from "./OnboardingTrueFalseQuestion";
import OnboardingMatchTheFollowingQuestion from "./OnboardingMatchTheFollowingQuestion";
import OnboardingMultipleChoiceQuestionLiveChart from "./OnboardingMultipleChoiceQuestionLiveChart";

import AnswerFeedback from '../../components/practicesession/AnswerFeedback';

const MagicMoment = () => {
  const [question, setQuestion] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    document.body.style.backgroundColor = "#000";
    document.body.style.color = "#fff";
    return () => {
      document.body.style.backgroundColor = "";
      document.body.style.color = "";
    };
  }, []);

  useEffect(() => {
    const fetchQuestion = async () => {
      //console.log("🚀 Fetching Magic Moment question...");
      try {
        const q = query(
          collection(db, "questions_magic_moment_new"),
          where("lessonid", "==", "magic-moment-1.0"),
          where("active", "==", "1")
        );
        const snapshot = await getDocs(q);
        
        console.log(`📥 Snapshot size: ${snapshot.size}`);

        if (snapshot.empty) {
          console.warn("⚠️ No questions found for magic-moment-1.0");
          setQuestion(null);
          return;
        }

        // Select one question randomly
        const lessonQuestions = snapshot.docs.map((doc) => doc.data());
        const randomIndex = Math.floor(Math.random() * lessonQuestions.length);
        const selectedQuestion = lessonQuestions[randomIndex];

        //console.log("🎯 Selected Question:", selectedQuestion);
        setQuestion(selectedQuestion);
      } catch (error) {
        console.error("❌ Error fetching questions:", error);
        navigate("/error");
      } finally {
        setLoading(false);
        //console.log("✅ Fetching questions complete.");
      }
    };

    fetchQuestion();
  }, [db, navigate]);

  const handleNext = async () => {
    await saveUserPracticeSession();
    navigate("/coins-reward");
  };

//   const saveUserPracticeSession = async () => {
//     const user = auth.currentUser;
//     if (user) {
//       const sessionData = {
//         challengeid: "magic-moment-1.0",
//         date: Timestamp.now(),
//         lessonid: "magic-moment-1.0",
//         userid: user.uid,
//         channel:"1",
//       };
//       await addDoc(collection(db, "userpracticesessions"), sessionData);
//       //console.log("✅ Practice session saved:", sessionData);
//     } else {
//       console.error("❌ No authenticated user found!");
//     }
//   };

const saveUserPracticeSession = async () => {
    const user = auth.currentUser;
    if (user) {
      const sessionData = {
        challengeid: "magic-moment-1.0",
        date: Timestamp.now(),
        lessonid: "magic-moment-1.0",
        userid: user.uid,
        channel: "1",
      };
  
      try {
        // Save user practice session
        await addDoc(collection(db, "userpracticesessions"), sessionData);
        //console.log("✅ Practice session saved:", sessionData);
  
        // Find user's token document
        const tokensQuery = query(
          collection(db, "usertotaltokens"),
          where("userid", "==", user.uid)
        );
        const tokensSnapshot = await getDocs(tokensQuery);
  
        if (!tokensSnapshot.empty) {
          const tokenDocRef = tokensSnapshot.docs[0].ref;
  
          // ✅ Use updateDoc instead of tokenDocRef.update
          await updateDoc(tokenDocRef, {
            totaltokens: 100,
            date: Timestamp.now(),
          });
  
          console.log(`✅ Updated tokens for user ${user.uid} to 100`);
        } else {
          console.warn(`⚠️ No usertotaltokens document found for user ${user.uid}`);
        }
  
      } catch (error) {
        console.error("❌ Error in saveUserPracticeSession or token update:", error);
      }
  
    } else {
      console.error("❌ No authenticated user found!");
    }
  };
  

  if (loading) {
    //console.log("⏳ Loading questions...");
    return <p style={{ color: "#fff", textAlign: "center" }}>Loading...</p>;
  }

  if (!question) {
    console.warn("⚠️ No question available to display.");
    return <p style={{ color: "#fff", textAlign: "center" }}>No question available.</p>;
  }

  //console.log("🔎 Current question:", question);

  return (
    <>
      <ProgressBar now={100} variant="success" />
      <div style={{ backgroundColor: "#000", color: "#fff", padding: "20px" }}>
        {question.questiontypeid === "1" && (
          <OnboardingMultipleChoiceQuestion 
            question={question} 
            onNext={handleNext} 
          />
        )}
        {question.questiontypeid === "2" && (
          <OnboardingTrueFalseQuestion 
            question={question} 
            onNext={handleNext} 
          />
        )}
        {question.questiontypeid === "3" && (
          <OnboardingMatchTheFollowingQuestion 
            question={question} 
            onNext={handleNext} 
          />
        )}
        {question.questiontypeid === "6.1" || question.questiontypeid === "tv-live-charts.1" && (
          <OnboardingMultipleChoiceQuestionLiveChart 
            question={question} 
            onNext={handleNext} 
          />
        )}
        {["1", "2", "3", "6.1", "tv-live-charts.1"].indexOf(question.questiontypeid) === -1 && (
          <p style={{ color: "#fff", textAlign: "center" }}>
            ⚠️ Unsupported question type: {question.questiontypeid}
          </p>
        )}
      </div>
    </>
  );
};

export default MagicMoment;
